import { render, staticRenderFns } from "./LoginDropdownView.vue?vue&type=template&id=55d24e84"
import script from "./LoginDropdownView.vue?vue&type=script&lang=js"
export * from "./LoginDropdownView.vue?vue&type=script&lang=js"
import style0 from "./LoginDropdownView.vue?vue&type=style&index=0&id=55d24e84&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports